"use strict";

function makeTrashable(promise) {
  var trash = function trash() {};

  var wrappedPromise = new Promise(function (resolve, reject) {
    trash = function trash() {
      resolve = null;
      reject = null;
    };

    promise.then(function (val) {
      if (resolve) resolve(val);
    }, function (error) {
      if (reject) reject(error);
    });
  });

  wrappedPromise.trash = trash;
  return wrappedPromise;
}

module.exports = makeTrashable;